import { render, staticRenderFns } from "./bottom_page.vue?vue&type=template&id=a52d1268"
import script from "./bottom_page.vue?vue&type=script&lang=js"
export * from "./bottom_page.vue?vue&type=script&lang=js"
import style0 from "./bottom_page.vue?vue&type=style&index=0&id=a52d1268&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports